import React from 'react';

interface SupportPageProps {}

const SupportPage: React.FC<SupportPageProps> = () => {
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      lineHeight: 1.6,
      color: '#333',
      backgroundColor: '#f5f5f5',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg,rgb(96, 7, 174),rgb(100, 8, 174))',
        color: 'white',
        padding: '2rem 0',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          marginBottom: '0.5rem',
          fontWeight: 300
        }}>
          UNISON
        </h1>
        <p style={{
          fontSize: '1.1rem',
          opacity: 0.9
        }}>
          Conferences App Support
        </p>
      </div>

      {/* Main Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{
          background: 'white',
          margin: '2rem auto',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          
          {/* About Section */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              About UNISON Conferences
            </h2>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              The UNISON Conferences app is the official mobile application for UNISON conference attendees. Access conference schedules, venue information, documents, and connect with other delegates all in one convenient app.
            </p>
          </div>

          {/* App Features */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              App Features
            </h2>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Conference Access:</strong> Browse and join available conferences
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Quick Access Dashboard:</strong> Easy navigation to key conference information
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Schedule & Timetable:</strong> View conference schedules and fringe events
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Documents:</strong> Access conference documents and SOC reports
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Health & Safety:</strong> Important safety information and guidelines
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Venue Details:</strong> Location and facility information
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Attendee Chat:</strong> Connect and communicate with other delegates
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Accessibility:</strong> Dark mode and text size options for better accessibility
              </li>
            </ul>
          </div>

          {/* Getting Started */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              Getting Started
            </h2>
            <h3 style={{
              color: '#495057',
              margin: '1.5rem 0 0.5rem 0',
              fontSize: '1.2rem'
            }}>
              Signing In
            </h3>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              Use your UNISON credentials or access code to sign into the app and access conference content.
            </p>
            
            <h3 style={{
              color: '#495057',
              margin: '1.5rem 0 0.5rem 0',
              fontSize: '1.2rem'
            }}>
              Selecting a Conference
            </h3>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              From the main screen, select an available conference to access its content and features.
            </p>
            
            <h3 style={{
              color: '#495057',
              margin: '1.5rem 0 0.5rem 0',
              fontSize: '1.2rem'
            }}>
              Navigation
            </h3>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              Use the bottom navigation bar to access different sections: Home, Schedule, Chat, Venue, and Profile.
            </p>
          </div>

          {/* FAQ */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              Frequently Asked Questions
            </h2>
            
            <div style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                fontWeight: 600,
                color: '#495057',
                marginBottom: '0.5rem'
              }}>
                How do I access a conference?
              </div>
              <div style={{ color: '#666' }}>
                You can access conferences through the main screen by selecting from available conferences, or by using an access code if you have one.
              </div>
            </div>
            
            <div style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                fontWeight: 600,
                color: '#495057',
                marginBottom: '0.5rem'
              }}>
                I can't sign in to my account
              </div>
              <div style={{ color: '#666' }}>
                Ensure you're using your correct UNISON credentials. If you continue to have issues, contact UNISON support for assistance with your account.
              </div>
            </div>
            
            <div style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                fontWeight: 600,
                color: '#495057',
                marginBottom: '0.5rem'
              }}>
                How do I change text size or enable dark mode?
              </div>
              <div style={{ color: '#666' }}>
                Go to your Profile tab, then under Accessibility settings you can toggle Dark Mode and adjust Text Size to your preference.
              </div>
            </div>
            
            <div style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                fontWeight: 600,
                color: '#495057',
                marginBottom: '0.5rem'
              }}>
                How do I delete my account?
              </div>
              <div style={{ color: '#666' }}>
                In your Profile settings, scroll to the bottom and select "Delete My Account". This will permanently remove your account and all associated data.
              </div>
            </div>
            
            <div style={{
              marginBottom: '1.5rem',
              padding: '1rem',
              background: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <div style={{
                fontWeight: 600,
                color: '#495057',
                marginBottom: '0.5rem'
              }}>
                The app isn't working properly
              </div>
              <div style={{ color: '#666' }}>
                Try closing and reopening the app. If issues persist, try signing out and signing back in. For technical issues, contact our support team.
              </div>
            </div>
          </div>

          {/* Privacy & Data */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              Privacy & Data
            </h2>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              UNISON is committed to protecting your privacy. The app collects minimal necessary information to provide conference services. You can:
            </p>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                View our Privacy Policy within the app
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                Control notification settings
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                Delete your account and associated data at any time
              </li>
            </ul>
          </div>

          {/* Technical Support */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              Technical Support
            </h2>
            <div style={{
              background: '#f8f9fa',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #7b2cbf',
              margin: '1rem 0'
            }}>
              <h3 style={{
                color: '#7b2cbf',
                marginTop: 0,
                marginBottom: '1rem'
              }}>
                Need Help?
              </h3>
              <p style={{ marginBottom: '0.5rem', color: '#666' }}>
                If you're experiencing technical issues or need assistance with the app, please contact our support team:
              </p>
              <p style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Developer:</strong> <a href="https://microbt.co.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#7b2cbf' }}>microbt.co.uk</a>
              </p>
              <p style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>Support Email:</strong> <a href="mailto:info@microbt.co.uk" style={{ color: '#7b2cbf' }}>info@microbt.co.uk</a>
              </p>
              <p style={{ marginBottom: '0.5rem', color: '#666' }}>
                <strong>UNISON Website:</strong> <a href="https://unison.org.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#7b2cbf' }}>unison.org.uk</a>
              </p>
            </div>
          </div>

          {/* System Requirements */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              System Requirements
            </h2>
            <h3 style={{
              color: '#495057',
              margin: '1.5rem 0 0.5rem 0',
              fontSize: '1.2rem'
            }}>
              iOS & Android
            </h3>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                iOS 12.0 or later / Android 6.0 or later
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                Compatible with iPhone, iPad, and Android devices
              </li>
              <li style={{ marginBottom: '0.5rem', color: '#666' }}>
                Internet connection required
              </li>
            </ul>
          </div>

          {/* App Updates */}
          <div style={{ marginBottom: '2rem' }}>
            <h2 style={{
              color: '#7b2cbf',
              marginBottom: '1rem',
              fontSize: '1.5rem',
              borderBottom: '2px solid #e9ecef',
              paddingBottom: '0.5rem'
            }}>
              App Updates
            </h2>
            <p style={{ marginBottom: '0.5rem', color: '#666' }}>
              We regularly update the UNISON Conferences app to improve performance and add new features. Make sure to keep your app updated through the App Store or Google Play Store to get the latest improvements.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        color: '#666',
        background: 'white',
        marginTop: '2rem'
      }}>
        <p>&copy; 2025 UNISON. All rights reserved.</p>
        <p>App developed by <a href="https://microbt.co.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#7b2cbf' }}>microbt.co.uk</a></p>
        <p>This support page is for the UNISON Conferences mobile application.</p>
      </div>
    </div>
  );
};

export default SupportPage;